/* eslint-disable prefer-destructuring,jsx-a11y/control-has-associated-label */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/display-name */
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { PropTypes } from 'prop-types';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

import { SETTINGS_US_STATES } from '../../utilities/sharedQueries';
import {
  Dropdown,
  MenuList,
  Option,
  SelectMenu,
  Placeholder,
  ValueContainer,
  Control,
  IndicatorsContainer,
  ChevronDown,
} from '../LargeList';

const SelectUSStateDropdown = ({
  value,
  placeholder,
  name,
  getOptionLabel,
  isOptionSelected,
  onChange,
  handleBlur,
  clearError,
  className,
  optionName,
  prefix,
  fieldsInfo,
  containerClass,
  dropDownParentClass,
}) => {
  const { t: translate } = useTranslation();
  const { data: usStatesData, isLoading: isLoadingUSStates } = useQuery(SETTINGS_US_STATES);
  const [isOpened, setIsOpened] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  const regexOnlyNumber = /[0-9]/g;
  let searchInput;
  let countryCode;

  const OPTION_HEIGHT = 44;
  const ROWS = 6;

  const [displayPlaceholder, setDisplayPlaceholder] = useState(false);

  const filterOption = ({ data }, string) => {
    if (string === '') return true;
    const str = string.replace(prefix, '').toLowerCase();
    return data.postal_abbreviation.toLowerCase().indexOf(str) !== -1;
  };

  const toggleFormGroupHeight = (e) => {
    setIsOpened(!isOpened);
    if (!e.target) {
      e.target = document.getElementsByClassName('select_menu-container')[0];
    }
    const parentFormControl = e.target.closest('.form_group-container');
    const parentModal = e.target.closest('.modal-content');
    if (parentModal) {
      if (!isOpened) {
        parentModal.style.minHeight = '51.5rem';
        parentModal.style.height = 'auto';
      } else {
        parentModal.style.minHeight = '';
        parentModal.style.height = '51.5rem';
      }
    }
    if (!isOpened && parentFormControl) {
      parentFormControl.style.height = `${parentFormControl.offsetHeight + OPTION_HEIGHT * ROWS}px`;
    } else if (parentFormControl) {
      parentFormControl.style.height = 'auto';
    }
  };

  const onSelectChange = (e) => {
    onChange(e, name);
    toggleFormGroupHeight(e);
    countryCode.value = `${prefix}${e[optionName]}`;
    setSelectedValue(e[optionName]);
  };

  const Input = (props) => (
    <>
      <input
        id={props.id}
        onFocus={props.onFocus}
        maxLength={2}
        type="text"
        onChange={(e) => {
          e.target.value = e.target.value.replace(regexOnlyNumber, '');
          e.target.defaultValue = props.selectProps.value;
          props.onChange(e);
        }}
        onBlur={props.onBlur}
        className="form-control-search bg-light border-0 ps-4"
        autoComplete="off"
        placeholder={translate('search_state_code')}
        style={{ height: '2.5rem', lineHeight: '2.5rem' }}
        ref={(e) => {
          if (e) {
            searchInput = e.target || e;
          }
        }}
      />
      <i
        style={{ left: 5 }}
        className="icon-search icon-search-other text-shadow"
        role="button"
        aria-label="Search"
        tabIndex="-1"
      />
    </>
  );

  Input.propTypes = {
    id: PropTypes.string.isRequired,
    onFocus: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    selectProps: PropTypes.oneOfType([PropTypes.object]).isRequired,
  };

  const triggerInput = (e) => {
    const elm = e.target || e;
    try {
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
        window.HTMLInputElement.prototype,
        'value'
      ).set;
      nativeInputValueSetter.call(searchInput, elm.value);
      const event = new Event('input', { bubbles: true });
      setSelectedValue(elm.value);
      searchInput.dispatchEvent(event);
    } catch (err) {
      return false;
    }
    return true;
  };

  const arrowIconClass = isOpened ? 'text-primary' : 'text-shadow';

  return (
    <>
      <Dropdown
        isOpen={isOpened}
        onClose={toggleFormGroupHeight}
        dropDownParentClass={dropDownParentClass}
        target={
          <>
            <input
              autoComplete="off"
              type="text"
              className="bg-transparent w-100 form-control-input my-0"
              placeholder={placeholder}
              defaultValue={`${prefix}${selectedValue}`}
              required
              name={name}
              onChange={triggerInput}
              readOnly
              onFocus={() => setDisplayPlaceholder(true)}
              onBlur={() => setDisplayPlaceholder(false)}
              onClick={(e) => {
                toggleFormGroupHeight(e);
              }}
              ref={(e) => {
                if (e) {
                  countryCode = e;
                }
              }}
            />
            <i
              tabIndex={0}
              className={`${arrowIconClass} position-absolute top-50 end-0 translate-middle-y`}
              role="button"
              onClick={(e) => {
                toggleFormGroupHeight(e);
              }}
              onKeyDown={() => {}}>
              <ChevronDown style={{ transform: `rotate(${isOpened ? '180deg' : '0deg'})` }} />
            </i>
            {displayPlaceholder && <label className="floating-label">{placeholder}</label>}
            <label className="error-label">{translate('input_required_error_label')}</label>
          </>
        }>
        <Select
          autoFocus
          backspaceRemovesValue={false}
          filterOption={filterOption}
          components={{
            IndicatorSeparator: null,
            MenuList,
            Option,
            Menu: SelectMenu,
            Input,
            Placeholder,
            ValueContainer,
            Control,
            IndicatorsContainer,
          }}
          controlShouldRenderValue={false}
          hideSelectedOptions={false}
          isClearable={false}
          isLoading={isLoadingUSStates}
          menuIsOpen
          onChange={onSelectChange}
          options={usStatesData?.usStates}
          tabSelectsValue={false}
          value={selectedValue}
          className={className}
          onBlur={(e) => {
            handleBlur(e);
            toggleFormGroupHeight(e);
          }}
          onFocus={(e) => {
            clearError(e);
          }}
          getOptionLabel={getOptionLabel}
          isOptionSelected={isOptionSelected}
          fieldsInfo={fieldsInfo}
          containerClass={containerClass}
        />
      </Dropdown>
    </>
  );
};

export default SelectUSStateDropdown;

SelectUSStateDropdown.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  handleBlur: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  isOptionSelected: PropTypes.func.isRequired,
  getOptionLabel: PropTypes.func.isRequired,
  className: PropTypes.string,
  optionName: PropTypes.string.isRequired,
  prefix: PropTypes.string.isRequired,
  fieldsInfo: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
  containerClass: PropTypes.string,
  dropDownParentClass: PropTypes.string,
};

SelectUSStateDropdown.defaultProps = {
  containerClass: 'w-100 position-absolute bg-lighter rounded shadow-lg p-2 mt-2',
  className: '',
  dropDownParentClass: 'w-100 pe-3',
};
